var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "menu-back",
  "use": "menu-back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"menu-back\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\" stroke-width=\"2\" d=\"M22.184 37.597 9.208 24.607l12.977-12.99M9.21 24.608h29.999\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol